import { BaseService } from "../../base";
export class LocationService extends BaseService {
  static get entity() {
    return "location";
  }
  static get name() {
    return "location";
  }

  static async findByNodeId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id/${id}`, this.name);
  }
}
